import type React from "react";

import { InputPopoverContext } from "./inputPopoverContext";

import { useInputPopover } from "@components/organisms/inputPopover/useInputPopover";
import type { IInputPopoverOptions } from "@components/organisms/inputPopover/types";

export function InputPopover({
  children,
  ...restOptions
}: {
  children: React.ReactNode;
} & IInputPopoverOptions) {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const popover = useInputPopover({ ...restOptions });

  return (
    <InputPopoverContext.Provider value={popover}>
      {children}
    </InputPopoverContext.Provider>
  );
}
